import { useState, useEffect } from "react";
import { Stack, TextField } from "@fluentui/react";
import { Button, Tooltip } from "@fluentui/react-components";
import { Send28Filled } from "@fluentui/react-icons";
import { useMsal } from "@azure/msal-react";

import { isLoggedIn, requireLogin } from "../../authConfig";
import styles from "./QuestionInput.module.css";
import { SpeechInput } from "./SpeechInput";

interface Props {
    onSend: (question: string) => void;
    disabled: boolean;
    initQuestion?: string;
    placeholder?: string;
    clearOnSend?: boolean;
    showSpeechInput?: boolean;
}

export const QuestionInput = ({ onSend, disabled, placeholder, clearOnSend, initQuestion, showSpeechInput }: Props) => {
    const [question, setQuestion] = useState<string>("");

    useEffect(() => {
        initQuestion && setQuestion(initQuestion);
    }, [initQuestion]);

    const sendQuestion = () => {
        if (disabled || !question.trim()) {
            return;
        }

        onSend(question);

        if (clearOnSend) {
            setQuestion("");
        }
    };

    const onEnterPress = (ev: React.KeyboardEvent<Element>) => {
        if (ev.key === "Enter" && !ev.shiftKey) {
            ev.preventDefault();
            sendQuestion();
        }
    };

    const onQuestionChange = (_ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (!newValue) {
            setQuestion("");
        } else if (newValue.length <= 1000) {
            setQuestion(newValue);
        }
    };

    const { instance } = useMsal();
    const disableRequiredAccessControl = requireLogin && !isLoggedIn(instance);
    const sendQuestionDisabled = disabled || !question.trim() || requireLogin;

    if (disableRequiredAccessControl) {
        placeholder = "Please login to continue...";
    }

    return (
        // <Stack horizontal className={styles.questionInputContainer}>
        //     <TextField
        //         className={styles.questionInputTextArea}
        //         disabled={disableRequiredAccessControl}
        //         placeholder={placeholder}
        //         multiline
        //         resizable={false}
        //         borderless
        //         value={question}
        //         onChange={onQuestionChange}
        //         onKeyDown={onEnterPress}
        //     />
        //     <div className={styles.questionInputButtonsContainer}>
        //         <Tooltip content="Submit question" relationship="label">
        //             <Button size="large" icon={<Send28Filled primaryFill="rgba(115, 118, 225, 1)" />} disabled={sendQuestionDisabled} onClick={sendQuestion} />
        //         </Tooltip>
        //     </div>
        //     {showSpeechInput && <SpeechInput updateQuestion={setQuestion} />}
        // </Stack>
        <Stack horizontal className={styles.questionInputContainer}>
        <div className={styles.inputWrapper}>
            {/* Styled Input Field */}
            <TextField
                className={styles.questionInputTextArea}
                disabled={disableRequiredAccessControl}
                placeholder={placeholder || "Type here..."}
                multiline={false}
                resizable={false}
                borderless
                value={question}
                onChange={onQuestionChange}
                onKeyDown={onEnterPress}
            />
            {/* Send Button */}
            <div className={styles.sendButton} onClick={sendQuestion}>
                <Send28Filled className={styles.sendIcon} />
            </div>
        </div>
    </Stack>
    
    );
};
